export enum ContactsListSortDirection {
    ascending = 0,
    descending = 1,
}
